
import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';

import SVGIcon from '../../../../../components/SVGIcon';

import Translatable from '../../../../Translatable';

import styles from './styles.js';

const FlyoutNavLink = ({
    icon,
    newText,
    title,
    url
}) => {
    return (
        <li aria-hidden="false">
            <Translatable attributes={{ title }}>
                <a
                    href={url}
                    className={css(styles.link)}
                    role="menuitem"
                >
                    <div className={css(styles.containerTable)}>
                        <div className={css(styles.containerTableCell, styles.containerTableCell_fullWidth, styles.containerTableCell_alignMiddle)}>
                            <Translatable content={title} />
                            {' '}
                            {newText &&
                                <Translatable content={{ transKey: 'nav.new' }}>
                                    <span className={css(styles.newText)} />
                                </Translatable>
                            }
                        </div>
                        {
                            icon ?
                                <div className={css(styles.containerTableCell, styles.containerTableCell_alignMiddle)}>
                                    <SVGIcon type={icon} />
                                </div> : null
                        }
                    </div>
                </a>
            </Translatable>
        </li>
    );
};

FlyoutNavLink.propTypes = {
    icon: PropTypes.string,
    newText: PropTypes.bool,
    title: PropTypes.object.isRequired,
    url: PropTypes.string.isRequired
};

export default FlyoutNavLink;



// WEBPACK FOOTER //
// ./src/components/Header/FlyoutMenu/FlyoutNav/FlyoutNavLink/FlyoutNavLink.jsx